import React from 'react';

/**
 * Le chargement d'une section de paramétrage.
 *
 * Toujours accompagné d'un libellé : un disque qui tourne seul ne dit pas si
 * l'écran attend le serveur ou s'il est bloqué.
 *
 * L'accent est celui de la section — l'onglet garde ainsi sa couleur même
 * pendant le chargement, et l'on voit où l'on est avant que le contenu arrive.
 *
 * La norme : PARAMETRAGE-MODULES.md §6.
 */
const ChargementSection = ({ accent = '#246990', libelle = 'Chargement de la configuration…' }) => (
  <div className="flex flex-col items-center justify-center py-20 gap-3">
    <div
      className="animate-spin rounded-full h-10 w-10 border-[3px] border-gray-200"
      style={{ borderTopColor: accent }}
    />
    <p className="text-sm text-gray-400 font-medium">{libelle}</p>
  </div>
);

export default ChargementSection;
